import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AdminAuthProvider, useAdminAuth } from "@/contexts/AdminAuthContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import QuoteCalculator from "@/components/QuoteCalculator";
import ShipmentTracking from "@/components/ShipmentTracking";
import Testimonials from "@/components/Testimonials";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileStickyQuoteCta from "@/components/MobileStickyQuoteCta";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

// Public site
const PublicSite = () => (
  <LanguageProvider>
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <QuoteCalculator />
      <ShipmentTracking />
      <Testimonials />
      <Gallery />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <MobileStickyQuoteCta />
  </LanguageProvider>
);

// Protected admin route
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAdminAuth();
  return isAuthenticated ? children : <Navigate to="/admin" replace />;
};

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
